import * as React from 'react';
export const standardcharteredSvg = React.forwardRef(
  function standardcharteredSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F5F6F8',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M18.619 18.143c-.871-.394-1.74-.793-2.613-1.181-1.86-.83-3.732-1.634-5.581-2.488-.932-.43-1.753-1.032-2.283-1.948-.902-1.557-.58-3.764.764-5.085.304-.3.684-.522 1.028-.78-.025.1-.043.201-.076.298-.246.72-.211 1.406.338 1.972.247.255.562.465.882.626.621.313 1.266.582 1.905.86.418.182.843.35 1.265.524 2.534 1.127 5.069 2.253 7.6 3.384.892.399 1.714.898 2.345 1.665 1.39 1.692 1.129 4.355-.576 5.726-.293.236-.633.412-.952.616.029-.068.063-.134.086-.203.086-.27.233-.54.241-.812.024-.826-.433-1.396-1.134-1.75-.792-.4-1.61-.745-2.422-1.107-.267-.119-.544-.212-.817-.317Z',
        fill: '#0172AA',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M14.09 19.79c1.51.671 3.023 1.34 4.534 2.015 1.248.558 2.51 1.086 3.734 1.694 1.066.53 1.921 1.318 2.29 2.494.444 1.412.149 2.716-.671 3.926-.555-.359-1.058-.753-1.617-1.032a159.992 159.992 0 0 0-5.014-2.407c-2.235-1.021-4.494-1.99-6.734-3-.951-.429-1.803-1.003-2.445-1.855-1.047-1.39-1.1-4.241 1.046-5.707.26-.178.527-.347.791-.52-.034.086-.06.177-.105.258-.431.767-.296 1.731.382 2.293.326.27.714.48 1.101.66.867.4 1.75.764 2.627 1.142l.01.006.07.032Z',
        fill: '#22AA47',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M14.248 10.94c-.422-.173-.847-.34-1.265-.523-.64-.279-1.284-.547-1.905-.86a3.295 3.295 0 0 1-.882-.626c-.55-.566-.584-1.252-.338-1.972.033-.097.051-.199.076-.298l.003.008.038-.018-.037-.046c1.518-.93 3.036-1.86 4.554-2.788.875-.535 1.753-1.064 2.622-1.606.165-.103.285-.094.441.009 1.86 1.219 2.022 3.913.254 5.25-.951.72-2.012 1.294-3.023 1.934-.186.118-.377.229-.555.358-.442.32-.463.66-.075 1.045.038.038.062.089.092.134Zm1.664 15.85c-.624.396-1.235.786-1.85 1.173s-1.226.783-1.852 1.154c-1.414.837-2.837.732-4.071-.313-.637-.54-.997-1.249-1.13-2.074-.035-.218.033-.35.23-.464 1.009-.588 2.007-1.196 3.017-1.782.115-.067.309-.1.423-.05 1.718.755 3.429 1.525 5.141 2.293.026.011.047.032.092.063Z',
        fill: '#78ADD1',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M16.607 11.154c.71-.427 1.348-.813 1.988-1.197 1.403-.843 2.81-1.683 4.21-2.534.163-.1.273-.096.43.01 1.969 1.327 2.008 4.068.067 5.443-.335.237-.697.438-1.057.637-.074.041-.206.033-.289-.004-1.597-.697-3.19-1.4-4.785-2.104l-.564-.25Z',
        fill: '#A4CFA0',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M18.619 18.143c.273.105.55.198.817.317.811.362 1.63.708 2.422 1.107.7.354 1.158.924 1.134 1.75-.008.273-.155.542-.241.811-.023.07-.057.136-.086.204l.002-.007-.063.074c-.107.132-.224.182-.398.105-1.756-.782-3.515-1.559-5.334-2.364.352-.2.663-.374.97-.554.198-.117.398-.232.582-.368.483-.357.52-.584.195-1.075Z',
        fill: '#78ADD1',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M14.009 19.752c-.877-.38-1.76-.743-2.627-1.143-.387-.18-.775-.39-1.101-.66-.678-.562-.813-1.526-.382-2.293.045-.08.07-.172.105-.258.11-.022.243-.097.328-.06 1.75.765 3.496 1.542 5.242 2.318.017.007.03.022.086.065-.289.17-.563.328-.835.49-.254.152-.513.297-.756.465-.456.314-.476.561-.106.978.023.026.031.065.046.098Z',
        fill: '#A3CFA0',
      }),
    );
  },
);
standardcharteredSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var standardchartered = {
  category: 'brand',
  colorable: false,
  name: 'standardchartered',
  svg: standardcharteredSvg,
};
